import styled, { css } from 'styled-components';

import { BREAKPOINTS } from '@shared/styled-system';

export const PageOverflow = styled.div`
	position: fixed;
	z-index: 997;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
`;

export const Wrapper = styled.div`
	align-items: center;
	color: ${({ theme }) => theme.colors.text.body};
	display: flex;
	position: relative;
	z-index: 998;
	cursor: pointer;
	padding: 0;

	@media (${BREAKPOINTS.DESKTOP}) {
		padding: 10px 16px;
	}
`;

export const DesktopIcon = styled.div`
	align-items: center;
	gap: 4px;
	font-size: 16px;
	line-height: 22px;
	font-weight: 400;
	vertical-align: middle;
	text-transform: uppercase;
	display: flex;
`;

export const Switcher = styled.div`
	background-color: ${({ theme }) => theme.colors.background.snackbar};
	border-radius: 12px;
	padding: 6px;
	position: absolute;
	right: 0;
	top: 100%;
	width: 146px;
	gap: 3px;
	display: flex;
	flex-direction: column;
	border: 1px solid ${({ theme }) => theme.colors.transparent.light10};
`;

export const Lang = styled.div<{ $isSelected?: boolean; $isFirst?: boolean }>`
	align-items: center;
	background-color: ${props => (props.$isSelected ? props.theme.colors.transparent.light15 : '')};
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	padding: 5px 8px;
	border-radius: 6px;

	${({ $isFirst }) =>
		$isFirst &&
		css`
			order: -1;
		`}
`;

export const LangLeft = styled.div`
	align-items: center;
	display: flex;
	gap: 4px;
	font-size: 16px;
	line-height: 22px;
	font-weight: 400;
	vertical-align: middle;
	text-transform: uppercase;
`;

export const LangCheckbox = styled.div<{ $selected?: boolean }>`
	background-color: ${props =>
		props.$selected ? props.theme.colors.icon.deposit : props.theme.colors.transparent.light15};
	border-radius: 50%;
	height: 20px;
	position: relative;
	width: 20px;

	&::before {
		background-color: ${({ theme, $selected }) => ($selected ? theme.colors.icon.alwaysWhite : 'none')};
		border-radius: 50%;
		content: '';
		display: block;
		height: 7px;
		left: 50%;
		position: absolute;
		transform: translate(-50%, -50%);
		top: 50%;
		width: 7px;
	}
`;
